import React from 'react'
import { Box, Typography } from '@material-ui/core'
import Breadcrumb from '../../Components/Breadcrumbs'
import { OutlinedButton } from '../../elements'
import { useStyles } from './style'

function ProgramSummaryReport() {
  const classes = useStyles()
  return (
    <Box>
      <Breadcrumb />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Program Summary Reports</Typography>
        <OutlinedButton label='Download CSV' />
      </Box>
    </Box>
  )
}

export default ProgramSummaryReport